import {HttpErrorResponse, HttpEvent, HttpInterceptorFn} from '@angular/common/http';
import {catchError, Observable, throwError} from "rxjs";
import {inject} from "@angular/core";
import {AuthService} from "@core/services/auth.service";
import {Router} from "@angular/router";
import {MessageService} from "primeng/api";

export const authInterceptor: HttpInterceptorFn = (req, next): Observable<HttpEvent<any>> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const messageService = inject(MessageService);
  let authReq = req;
  if (authService.isAuthenticated()) {
    const token = authService.getToken();
    if (token) {
      authReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`)
      });
    }
  }

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 0) {
        messageService.add({
          severity: 'error',
          summary: 'Erro de conexão',
          detail: 'Não foi possível conectar ao servidor. Verifique sua conexão.',
          life: 5000
        });
      }
      if (error.status === 401) {
        messageService.add({
          severity: 'warn',
          summary: 'Atenção!',
          detail: 'Usuário não autenticado ou sessão expirada.',
          life: 5000
        });
        authService.logout();
        router.navigate(['/auth/login']).then(() => {
        });
      }
      if (error.status === 403) {
        messageService.add({
          severity: 'error',
          summary: 'Acesso negado',
          detail: 'Você não possui permissão para realizar esta ação.',
          life: 5000
        });
        router.navigate(['/auth/no-permission'], {state: {from: 'interceptor'}}).then(() => {
        });
      }

      return throwError(() => error);
    })
  );
};
